export default {
    init() {
      this.openFaq();
    },

    openFaq() {
        $('.faq__wrapper').on('click', function (e){
            $(this).find('.faq__plus').toggleClass('faq__plus-open');
            $(this).find('.faq__answer').toggleClass('collapse')
        });
        /*$('.faq__body').click(function (e){
            $(this).find('.faq__arrow').toggleClass('faq__arrow-open');
            $(this).find('.faq__text').toggleClass('collapse')
        })*/


        $('.industries__body-wrapper-link').on('click', function (e) {
            let currentAttrValue = $(this).attr('href');

            // Отображение содержимого соответствующей вкладки
            //$('.features__body-wrapper-background-left #' + currentAttrValue).show().siblings().hide();

            $('.industries__tab').each(function () {
                if ($(this).hasClass('industries__tab-active')) {
                    $(this).removeClass('industries__tab-active');
                }
            })
            $('#' + currentAttrValue).addClass('industries__tab-active');

            // Изменение активной вкладки
            $(this).parent('div').addClass('features__body-wrapper-title').siblings().removeClass('features__body-wrapper-title');
            e.preventDefault();
        });

        $('.faq__menu-item').on('click', function() {
            console.log('aaaaaa');
            $('.faq__menu-item').removeClass('faq__menu-active');
            $(this).addClass('faq__menu-active');
            const category = $(this).data('category');
            $('.faq__category').removeClass('d-none').addClass('d-none');
            $(`.faq__category.${category}`).removeClass('d-none');
        });
    },
}
